module.exports = __webpack_public_path__ + "assets/5947c69498e2fb6c710c0bb36542e908.png";